<template>
	<sf-modal-layout size="l" :title="getMessage_('QWCC001854')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<part-popup-search ref="PartPopupSearch" :scrId="scrId" :partNum="propPartNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<part-popup-table ref="table" @close="close" @reload="reload" @SendPartData="sendPartData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from './store/helpers';
import PartPopupTable from './Content/Table/PartPopupTable.vue';
import PartPopupSearch from './Content/Search/PartPopupSearch.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PartPopupTable, PartPopupSearch },

	data() {
		return {
			show: false,
			propPartNo: ''
		};
	},
	created() {
		//들어오자마자 state 초기화 하는 방법
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.setStateInit_();
			this.show = true;
			this.propPartNo = param;
			this.setSearchParam_({ key: 'partNo', value: param });
			if (this.$refs.PartPopupSearch != undefined) {
				this.$refs.PartPopupSearch.search();
			}
		},
		close() {
			//this.setSearchParam_({ key: 'partNo', value: null });
			//this.$refs.PartPopupSearch.reset();
			this.show = false;
		},
		//partPopupSearch페이지 새로고침
		reload() {
			this.$refs.PartPopupSearch.search();
		},
		sendPartData(sendParam) {
			this.$emit('SendPartData', sendParam);
			this.close();
		}
	}
};
</script>

<style></style>
